const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveVoucherReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_VOUCHER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_VOUCHER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_VOUCHER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveVoucherReducer